import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Link,
} from '@material-ui/core';
import React, { useState } from 'react';
import { t } from 'ttag';
import { Close } from '@icons';
import useStyles from './styles';
import { Button, IconButton } from '@coolremote/shared';
import { Arrow as SvgArrow } from '@icons';
import DeleteAccountsDialog from '@components/DeleteAccountsDialog';

const DataAndPrivacy = ({ isOpen, onClose }) => {
  const classes = useStyles();
  const [isDeleteAccountOpen, setIsDeleteAccountOpen] = useState(false);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
      className={classes.dialog}
    >
      <div className={classes.titleContent}>
        <Typography
          className={classes.headerTitle}
        >{t`Data & Privacy`}</Typography>
        <IconButton
          disableRipple
          onClick={onClose}
          className={classes.iconBtnStyle}
        >
          <Close color="#7f7692" />
        </IconButton>
      </div>

      <DialogContent>
        <div className={classes.section}>
          <Typography className={classes.subHeader}>
            {t`Privacy Policy`}
          </Typography>

          <Link
            target="_blank"
            href={'https://coolautomation.com/privacy-policy/'}
            className={classes.subtitles}
          >
            {'https://coolautomation.com/privacy-policy/'}
          </Link>
        </div>

        <div className={classes.section}>
          <div
            className={classes.deleteAccountWrap}
            onClick={() => setIsDeleteAccountOpen(true)}
          >
            <Typography className={classes.subHeader}>
              {t`Delete User Account and All Data`}
            </Typography>
            <SvgArrow />
          </div>
        </div>
      </DialogContent>

      <DeleteAccountsDialog
        isOpen={isDeleteAccountOpen}
        onClose={() => setIsDeleteAccountOpen(false)}
      />

      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose} width={100} marginRight>
          {t`Close`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DataAndPrivacy;
